import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { SubscriptionState } from '@model/interfaces/payment.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IAccountData } from 'src/app/model/interfaces/account-admin.interface';

@Component({
  selector: 'mt-upgrade-subscription',
  templateUrl: './upgrade-subscription.component.html',
  styleUrls: ['./upgrade-subscription.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpgradeSubscriptionComponent {
  isCogsig = environment.isCogSig;

  /**
   * Hold Account basic information
   */
  @Input() accountData!: IAccountData;

  /**
   * Hold whether trial expired or cancelled or anyother state
   */
  @Input() subscriptionState!: SubscriptionState;

  constructor(public modal: NgbActiveModal) {}

  /**
   * Opens signitic application
   */
  openSignitic(): void {
    void window.open('https://www.signitic.com/en/try', '_blank');
  }
}
